












import Vue from 'vue'
import { CHART_SIZE } from '../sizes'

export default Vue.extend({
  name: 'ChartTitle',
  data: () => ({ CHART_SIZE }),
})
